<template>
    <div id="parcel_order_page">
        <router-view name="nav"></router-view>
        <router-view name="main"></router-view>
        <router-view name="modal_new"></router-view>
        <router-view name="modal_add"></router-view>
        <router-view name="modal_detail"></router-view>
        <router-view name="user_edit"></router-view>
        <router-view name="loading"></router-view>
        <router-view name="popup"></router-view>
    </div>
</template>

<script>
export default {
    created() {
        this.$store.commit("setPage", "parcelOrder");
    },
}
</script>

<style>
#parcel_order_page {
    width:100%;
}
</style>


// WEBPACK FOOTER //
// src/components/ParcelOrderPage.vue